import { Input } from "@thilke/ui/components/input";

export function InputDemo() {
  return (
    <div className="flex flex-col flex-wrap gap-4 md:flex-row">
      <Input type="email" placeholder="Email" />
      <Input type="text" placeholder="Error" aria-invalid="true" />
      <Input type="password" placeholder="Password" />
      <Input type="number" placeholder="Number" />
      <Input type="file" placeholder="File" />
      <Input type="tel" placeholder="Tel" />
      <Input type="text" placeholder="Text" />
      <Input type="url" placeholder="URL" />
      <Input type="search" placeholder="Search" />
      <Input disabled placeholder="Disabled" />
    </div>
  );
}
